import { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import ShopNav from '../../shopNav/ShopNav';
import Footer from '../../footer/footer';
import axios from 'axios';
//import html2canvas from 'html2canvas';
import ServiceHighlights from '../../servicehighlights/ServiceHighlights';
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import './PaymentResult.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faTimesCircle, faFilePdf, faArrowRightToBracket } from '@fortawesome/free-solid-svg-icons';

// ✅ Variable de entorno
const API_URL = import.meta.env.VITE_API_URL;

const PaymentResult = () => {
  const [status, setStatus] = useState(null);
  const [orderData, setOrderData] = useState(null);
  const navigate = useNavigate();
  const pdfRef = useRef(null);
  const API_BASE_URL = API_URL;

  useEffect(() => {
    const fetchOrder = async () => {
      const params = new URLSearchParams(window.location.search);
      const txStatus = params.get('bold-tx-status');
      const boldOrderId = params.get('bold-order-id');

      setStatus(txStatus);

      if (txStatus === 'approved' && boldOrderId) {
        try {
          const response = await axios.get(`${API_BASE_URL}/api/confirm-payment?orderId=${boldOrderId}`);
          setOrderData(response.data);
        } catch (error) {
          console.error('Error al obtener la orden:', error);
        }
      }
    };

    fetchOrder();
  }, []);

  const handleContinue = () => {
    navigate('/mi-cuenta');
  };

  const handleGeneratePDF = () => {
  if (!orderData) return;

  const pdf = new jsPDF();
  const pageWidth = pdf.internal.pageSize.getWidth();

  // ====== LOGO (70x70 centrado) ======
  const imgLogo = "/images/VPA.png";
  pdf.addImage(imgLogo, "PNG", pageWidth / 2 - 35, 8, 70, 70);

  // ====== ENCABEZADO ======
  pdf.setFontSize(20);
  pdf.setFont("helvetica", "bold");
  pdf.setTextColor(20, 90, 50);
  pdf.text("ORDEN DE VENTA", pageWidth / 2, 90, { align: "center" }); // bajado

  pdf.setFontSize(11);
  pdf.setFont("helvetica", "normal");
  pdf.setTextColor(80);
  pdf.text(`Número de orden: ${orderData.orden.numero_orden}`, pageWidth / 2, 98, { align: "center" });
  pdf.text(`Fecha: ${new Date(orderData.orden.fecha).toLocaleDateString("es-CO")}`, pageWidth / 2, 105, { align: "center" });

  pdf.setDrawColor(200);
  pdf.line(15, 112, pageWidth - 15, 112);

  // ====== DATOS DEL CLIENTE ======
  pdf.setFontSize(12);
  pdf.setFont("helvetica", "bold");
  pdf.setTextColor(20, 90, 50);
  pdf.text("Datos del Cliente", 15, 122);

  pdf.setFontSize(10);
  pdf.setFont("helvetica", "normal");
  pdf.setTextColor(60);

  let yCliente = 130;
  const datosCliente = [
    `Nombre: ${orderData.shipping.nombre}`,
    `Email: ${orderData.shipping.email}`,
    `Teléfono: ${orderData.shipping.telefono}`,
    `Dirección: ${orderData.shipping.direccion}`,
    `Ciudad: ${orderData.shipping.ciudad}, ${orderData.shipping.departamento}`,
    `ZIP: ${orderData.shipping.zip}`,
  ];

  datosCliente.forEach((line) => {
    pdf.text(line, 15, yCliente);
    yCliente += 6;
  });

  pdf.setDrawColor(200);
  pdf.line(15, yCliente + 2, pageWidth - 15, yCliente + 2);

  // ====== TABLA DE ÍTEMS ======
  autoTable(pdf, {
    startY: yCliente + 10,
    head: [["Producto", "Descripción", "Categoría", "Cantidad"]],
    body: orderData.items.map((item) => [
      item.nombre,
      item.descripcion || "-",
      item.categoria || "-",
      item.cantidad,
    ]),
    theme: "grid",
    headStyles: {
      fillColor: [20, 90, 50],
      textColor: 255,
      fontStyle: "bold",
    },
    bodyStyles: {
      textColor: 50,
    },
    alternateRowStyles: {
      fillColor: [240, 248, 244],
    },
    styles: {
      fontSize: 10,
      cellPadding: 5,
    },
  });

  // ====== TOTALES ======
  let finalY = pdf.lastAutoTable.finalY + 15;
  pdf.setFont("helvetica", "bold");
  pdf.setFontSize(13);
  pdf.setTextColor(20, 90, 50);
  pdf.text("TOTAL A PAGAR:", pageWidth - 90, finalY);

  pdf.setFontSize(16);
  pdf.setTextColor(0, 128, 0);
  pdf.text(`$${parseFloat(orderData.orden.total).toLocaleString("es-CO")}`, pageWidth - 15, finalY, { align: "right" });

  pdf.setDrawColor(200);
  pdf.line(15, finalY + 5, pageWidth - 15, finalY + 5);

  // ====== SLOGAN (centrado debajo del total) ======
  let sloganY = finalY + 25;
  pdf.setFontSize(12);
  pdf.setFont("helvetica", "italic");
  pdf.setTextColor(20, 90, 50);
  pdf.text(
    '"Donde el sonido se convierte en leyenda."',
    pageWidth / 2,
    sloganY,
    { align: "center" }
  );

  pdf.setFontSize(11);
  pdf.setFont("helvetica", "normal");
  pdf.text(
    "Vintage Pro Audio - tu aliado en el mundo del audio profesional",
    pageWidth / 2,
    sloganY + 7,
    { align: "center" }
  );

  // ====== PIE DE PÁGINA ======
  pdf.setFontSize(8);
  pdf.setFont("helvetica", "italic");
  pdf.setTextColor(120);
  pdf.text(
    "Gracias por tu compra. Esta orden fue procesada de forma segura.",
    pageWidth / 2,
    285,
    { align: "center" }
  );

  pdf.save(`orden_${orderData.orden.numero_orden}.pdf`);
};


  return (
    <>
      <ShopNav />
      <ServiceHighlights />

      <div className="container my-5">
        <section className="bg-light p-4 rounded shadow-sm">

          {/* Logo */}
          <div className="text-center mb-4">
            <img src="/images/VPA.png" alt="Mi Tienda" className="logo-header" />
          </div>

          <h2 className="text-center mb-4">Resultado del pago</h2>

          {status === 'approved' ? (
            orderData ? (
              <div ref={pdfRef}>
                <div className="text-center">
                  <div className="mb-3">
                    <FontAwesomeIcon icon={faCheckCircle} className="text-success" style={{ fontSize: '3rem' }} />
                  </div>
                  <p className="text-success fs-5 fw-bold">¡Pago aprobado con éxito!</p>
                  <p className="text-success fw-semibold">
                    Gracias por tu compra, {orderData.shipping?.nombre || orderData.user?.name}.
                  </p>
                </div>

                <div className="row g-4 mt-4">
                  {/* Resumen de orden */}
                  <div className="col-md-4">
                    <div className="card border-success h-100">
                      <div className="card-header bg-success text-white">Resumen de Orden</div>
                      <div className="card-body">
                        <p><strong>Número de orden:</strong> {orderData.orden.numero_orden}</p>
                        <p><strong>Estado:</strong> {orderData.orden.estado}</p>
                        <p><strong>Pago recibido:</strong> {orderData.orden.pago ? 'Sí' : 'No'}</p>
                        <p><strong>Total:</strong> ${parseFloat(orderData.orden.total).toLocaleString('es-CO')}</p>
                        <p><strong>Fecha:</strong> {new Date(orderData.orden.fecha).toLocaleString()}</p>
                        <p className="text-muted small">Transacción procesada de forma segura.</p>
                      </div>
                    </div>
                  </div>

                  {/* Ítems */}
                  <div className="col-md-4">
                    <div className="card border-info h-100">
                      <div className="card-header bg-info text-white">Ítems de la Orden</div>
                      <div className="card-body">
                        {orderData.items.map((item, index) => (
                          <div key={index} className="mb-3 border-bottom pb-2">
                            <p className="fw-bold">{item.nombre}</p>
                            <p className="mb-0">{item.descripcion}</p>
                            <small>Categoría: {item.categoria}</small><br />
                            {/* <small>Cantidad: {item.cantidad} | Precio unitario: ${parseFloat(item.precio_unitario).toLocaleString('es-CO')}</small> */}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>

                  {/* Envío */}
                  <div className="col-md-4">
                    <div className="card border-secondary h-100">
                      <div className="card-header bg-secondary text-white">Información de Envío</div>
                      <div className="card-body">
                        <p><strong>Nombre:</strong> {orderData.shipping.nombre}</p>
                        <p><strong>Email:</strong> {orderData.shipping.email}</p>
                        <p><strong>Teléfono:</strong> {orderData.shipping.telefono}</p>
                        <p><strong>Dirección:</strong> {orderData.shipping.direccion}</p>
                        <p><strong>Ciudad:</strong> {orderData.shipping.ciudad}, {orderData.shipping.departamento}</p>
                        <p><strong>ZIP:</strong> {orderData.shipping.zip}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="text-center mt-5">
                  <button className="btn btn-outline-danger me-2" onClick={handleGeneratePDF}>
                    <FontAwesomeIcon icon={faFilePdf} className="me-2" />
                    Descargar comprobante en PDF
                  </button>
                  <button className="btn btn-primary" onClick={handleContinue}>
                    <FontAwesomeIcon icon={faArrowRightToBracket} className="me-2" />
                    Ir a mi cuenta
                  </button>
                </div>

                <div className="text-center mt-3">
                  <a href="/pedidos" className="btn btn-link">Ver historial</a>
                  <a href="/tienda" className="btn btn-link">Seguir comprando</a>
                </div>
              </div>
            ) : (
              <p className="text-center">Cargando detalles de la orden...</p>
            )
          ) : (
            <div className="text-center">
              <FontAwesomeIcon icon={faTimesCircle} className="text-danger" style={{ fontSize: '3rem' }} />
              <p className="text-danger fs-5">El pago no fue aprobado.</p>
              <div className="text-center mt-4">
                <button className="btn btn-outline-secondary" onClick={handleContinue}>
                  Volver a mi cuenta
                </button>
              </div>
            </div>
          )}
        </section>
      </div>

      <Footer />
    </>
  );
};

export default PaymentResult;
